export enum TerrenoSituacao {
  NaoIniciado = 1,
  EmAnalise = 2,
  EmNegociacao = 3,
  FaseDeContrato = 4,
  StandBy = 5,
  NaoAtende = 6,
  Comprado = 7,
  Descartado = 8,
  EmEstudo = 9,
  ProjetoEmDesenvolvimento = 10,
  EmAprovacaoNaPrefeitura = 11,
  ProjetoAprovado = 12,
  ProjetoLegalizado = 13,
  ObraIniciada = 14,
  ObraEncerrada = 15,
  Distratado = 16
}
